import React from 'react'
import './Team.css'
import ContentManager from './ContentManager'

var Teamdetails = [
  { id: '1', h1: 'Pavan Kumar Dubasi', p1: 'President', imgUrl: "https://res.cloudinary.com/di1jyuoqd/image/upload/v1683484927/PAVAN_mhzfjd.jpg" },
  { id: '2', h1: 'Joshi Korada', p1: 'Vice-President', imgUrl: "https://res.cloudinary.com/di1jyuoqd/image/upload/v1683492512/joshi_vrgcww.jpg" },

]
var Teamdetails2 = [
  {id:'8',h1:'Sipun Mohanty',p1:'Treasurer',imgUrl:"https://res.cloudinary.com/di1jyuoqd/image/upload/v1683484803/sipun_yqfhif.png"},
  { id: '5', h1: 'Sasida N', p1: 'Secretary', imgUrl: "https://res.cloudinary.com/di1jyuoqd/image/upload/v1683484927/sasida_vpac3j.jpg" },
  { id: '6', h1: 'Sneha Das', p1: ' Event coordinator', imgUrl: "https://res.cloudinary.com/di1jyuoqd/image/upload/v1683484929/SNEHA_sgigcb.jpg" },
  { id: '7', h1: 'Bandana Yadav', p1: 'Activity coordinator', imgUrl: "https://res.cloudinary.com/di1jyuoqd/image/upload/v1683484904/bandana_1_ksea4w.jpg" },
  
]
var Teamdetails3 = [
  { id: '9', h1: 'Anurag Sahay', p1: 'Professor-Incharge', imgUrl: "https://res.cloudinary.com/di1jyuoqd/image/upload/v1683484899/anurag_ljbnx8.jpg" }
]
export default function Team() {

  return (
    <>

      <div className='Team'>
        <div className='Team-des'>
          <br>
          </br>
          <h1>Our Team</h1>
          <br>
          </br>
         
            <h6>

              Science and Environment is a highly interdisciplinary field that thrives well with the perfect amalgamation
              of individuals possessing knowledge of various domains. We believe that great work stems from
              the will to grow as a team and the passion to create something that leaves a mark.
              We are driven by our mindset to stand out and inspire while staying on our feet to be
              <br>
              </br>
              open to learn.
              Our team comprises students across all departments of NIT Patna who work and collaborate to bring innovative thoughts to life.

            </h6>
          
        </div>
        <br>
        </br>
        <br>
        </br>
        <ContentManager Contentdetails={Teamdetails3} preview={2} />
        <ContentManager Contentdetails={Teamdetails} preview={2} />
        <ContentManager Contentdetails={Teamdetails2} preview={2} />
      </div>

    </>
  )
}
